import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";

// scrolltop
import ScrollTop from "./component/scrollTop/ScrollTop";

// Main
import MainPage from "./views/main/MainPage";

// Product
import ProductPage from "./views/product/ProductPage";
import ProductDetailPage from "./views/product/ProductDetailPage";

// Search
import SearchResultPage from "./views/search/SearchResultPage";

// Shop
import WishListPage from "./views/shop/WishListPage";
import CartPage from "./views/shop/CartPage";
import PayPage from "./views/shop/PayPage";
import PayCompletePage from "./views/shop/PayCompletePage";

// Login
import LoginPage from "./views/login/LoginPage";
import SignUPPage from "./views/login/SignUpPage";
import SignCompletePage from "./views/login/SignCompletePage";

// Mypage
import DefaultMyPage from "./views/mypage/DefaultMyPage";
import MyMainPage from "./views/mypage/shopping/MyMainPage";
import MyOrderPage from "./views/mypage/shopping/MyOrderPage";
import MyOrderDetailPage from "./views/mypage/shopping/MyOrderDetailPage";
import MyCancelPage from "./views/mypage/shopping/MyCancelPage";
import MyCancelDetailPage from "./views/mypage/shopping/MyCancelDetailPage";
import MyEditPage from "./views/mypage/myinfo/MyEditPage";
import MyEditDetailPage from "./views/mypage/myinfo/MyEditDetailPage";
import MemOutPage from "./views/mypage/myinfo/MemOutPage";
import MemOutDetailPage from "./views/mypage/myinfo/MemOutDetailPage";
import MyPointPage from "./views/mypage/myinfo/MyPointPage";
import MyCouponPage from "./views/mypage/myinfo/MyCouponPage";
import MyGradePage from "./views/mypage/myinfo/MyGradePage";
import MyInquiryListPage from "./views/mypage/inquiry/MyInquiryListPage";
import MyInquiryPage from "./views/mypage/inquiry/MyInquiryPage";

// New password
import NewPwdPage from "./views/pwd/NewPwdPage";
import NewPwdCompletePage from "./views/pwd/NewPwdCompletePage";

// Notfound
import NotFound from "./views/NotFound";

export default function App() {
    return (
        <>
            <ScrollTop />
            <Routes>
                {/* Main */}
                <Route path="/" element={<MainPage />} />

                {/* ------------- Product ------------- */}
                {/* 상품페이지 */}
                <Route path="/product" element={<ProductPage />} />
                {/* 상품 상세페이지 */}
                <Route path="/product/detail/:id" element={<ProductDetailPage />} />

                {/* ------------- Search ------------- */}
                {/* 검색 결과 페이지 */}
                <Route path="/searchResult/*" element={<SearchResultPage />} />

                {/* ------------- Shop ------------- */}
                {/* 위시리스트 */}
                <Route path="/wish" element={<WishListPage />} />
                {/* 카트 */}
                <Route path="/cart" element={<CartPage />} />
                {/* 결제페이지 */}
                <Route path="/pay" element={<PayPage />} />
                {/* 결제 완료페이지 */}
                <Route path="/pay/complete" element={<PayCompletePage />} />

                {/* ------------- Login ------------- */}
                {/* Login 페이지 */}
                <Route path="/login" element={<LoginPage />} />
                {/* 회원가입 페이지 */}
                <Route path="/signup" element={<SignUPPage />} />
                <Route path="/signcomplete" element={<SignCompletePage />} />

                {/* ------------- Mypage ------------- */}
                <Route path="/mypage" element={<DefaultMyPage />}>
                    {/* 마이페이지 메인 */}
                    <Route path="mymain" element={<MyMainPage />} />
                    {/* 주문 배송 내역페이지 */}
                    <Route path="myorder" element={<MyOrderPage />} />
                    {/* 주문 배송내역 상세 페이지 */}
                    <Route path="order_detail/:id" element={<MyOrderDetailPage />} />
                    {/* 취소/교환/반품 내역페이지 */}
                    <Route path="mycancel" element={<MyCancelPage />} />
                    {/* 취소/교환/반품 상세 페이지 */}
                    <Route path="cancel_detail" element={<MyCancelDetailPage />} />
                    {/* 개인정보 수정 */}
                    <Route path="myedit" element={<MyEditPage />} />
                    {/* 개인정보 수정 상세페이지 */}
                    <Route path="myedit/detail" element={<MyEditDetailPage />} />
                    {/* 회원탈퇴 페이지 */}
                    <Route path="memberout" element={<MemOutPage />} />
                    {/* 회원탈퇴 페이지 */}
                    <Route path="memberout/detail" element={<MemOutDetailPage />} />
                    {/* 회원등급 페이지 */}
                    <Route path="mygrade" element={<MyGradePage />} />
                    {/* 적립금 페이지 */}
                    <Route path="mypoint" element={<MyPointPage />} />
                    {/* 쿠폰 페이지 */}
                    <Route path="mycoupon" element={<MyCouponPage />} />
                    {/* 1:1문의내역 페이지 */}
                    <Route path="myinquiry" element={<MyInquiryListPage />} />
                    {/* 1:1문의 신청 페이지 */}
                    <Route path="myinquiry/new" element={<MyInquiryPage />} />
                </Route>

                {/* ------------- new password ------------- */}
                {/* 새 비밀번호 설정 페이지 */}
                <Route path="/newPwd" element={<NewPwdPage />} />
                {/* 새 비밀번호 설정 완료 페이지 */}
                <Route path="/newPwd/complete" element={<NewPwdCompletePage />} />

                {/* Not Found */}
                <Route path="/*" element={<NotFound />} />
            </Routes>
        </>
    );
}
